var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteGrowth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.836 15.841A8.36 8.36 0 0 0 6.06 17.26l4.244-2.665a2.263 2.263 0 0 1 2.789.316l1.427 1.427C16.659 14.761 18 12.238 18 9.5 18 4.813 14.187 1 9.5 1S1 4.813 1 9.5a8.51 8.51 0 0 0 2.836 6.341zM9.88 10.25h-.76a2.122 2.122 0 0 1-.37-4.212V5.25a.75.75 0 0 1 1.5 0V6h1a.75.75 0 0 1 0 1.5H9.12a.62.62 0 0 0-.62.62c0 .352.278.63.62.63h.76a2.122 2.122 0 0 1 .37 4.212v.787a.75.75 0 0 1-1.5 0V13h-1a.75.75 0 0 1 0-1.5h2.13a.62.62 0 0 0 .62-.62.623.623 0 0 0-.62-.63z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 12h-4a1 1 0 0 0-.707 1.707L19.586 15 15.5 19.086l-3.293-3.293a1 1 0 0 0-1.233-.143l-10.5 6.5a1 1 0 0 0 1.052 1.7l9.826-6.083 3.44 3.44a.999.999 0 0 0 1.414 0L21 16.414l1.293 1.293A1 1 0 0 0 24 17v-4a1 1 0 0 0-1-1z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteGrowth);
export default __webpack_public_path__ + "static/media/whiteGrowth.b4485e50d653077afb5e1e249b8e9bd2.svg";
export { ForwardRef as ReactComponent };